import React from 'react';
import { CellProps, isNumberControl, RankedTester, rankWith, WithClassname } from '@jsonforms/core';
import { ChakraInputDecimal } from '../chakra-controls';
import { withNamedJsonFormsCellProps } from '@/forms-renderers/chakra-ui/utils/withNamedJsonFormsHOC';

export const ChakraDecimalCell = (props: CellProps & WithClassname) => <ChakraInputDecimal {...props} />;

export const chakraDecimalCellTester: RankedTester = rankWith(2, isNumberControl);
export default withNamedJsonFormsCellProps(ChakraDecimalCell);
